import React, { FC, memo } from "react";
import { IconTypesKeys } from "@evergis/ui";

import { Container } from "./styled";
import { AddFeatureButton } from "../components/AddFeatureButton/AddFeatureButton";
import { ContainerProps } from "../types";

export const AddFeatureContainer: FC<ContainerProps> = memo(({ elementConfig }) => {
  const { children, style } = elementConfig || {};

  return (
    <Container style={style}>
      {children
        .filter(({ type }) => type === "button")
        .map(({ options }, index) => (
          <AddFeatureButton
            key={index}
            icon={options?.icon as IconTypesKeys}
            title={options?.title}
            layerName={options?.layerName}
            geometryType={options?.geometryType}
          />
        ))}
    </Container>
  );
});
